import { Action } from 'redux';
import { FEEDBACK_TRIGGER } from 'src/modules/feedback/actions/FeedbackActions';
import { FeedbackState } from 'src/modules/feedback/types/FeedbackState';

export function feedbackTriggerReducer(state: FeedbackState, action: Action): FeedbackState {
  if (FEEDBACK_TRIGGER.isSuccess(action)) {
    return {
      ...state,
      feedbackModalOpened: state.feedbackModalOpened || action.data.triggered,
    };
  }

  return state;
}
